export default function AppLogo({ className = "w-10 h-10 rounded-md object-cover", alt = "Infoz IT Solutions logo" }) {
  return <img src="/assets/android-chrome-512x512.png" alt={alt} className={className} />;
}
